module.exports = __webpack_public_path__ + "static/media/vtex3.4227577e.png";